<div class="row">
  <div class="col-sm-12 overflow-box">
    <div class="card">
      <div class="card-header">
        <h5>Please authorize this deletion!</h5>
      </div>

      <list-errors [errors]="errors"></list-errors>

      <div class="card-block">
        <!-- Loader spinner -->
        <loader-animation [loading]="isSubmitting" [message]="'Deleting'">
        </loader-animation>
        <!-- Loader spinner -->

        <div class="j-wrapper j-wrapper-640">
          <form
            [hidden]="isSubmitting"
            class="j-pro form-control md-float-material"
            id="j-pro"
            [formGroup]="authForm"
          >
            <div class="j-content">
              <div class="j-row">
                <!-- start email -->
                <div class="j-span12 j-unit">
                  <div class="j-input">
                    <label class="j-icon-left" for="name">
                      <i class="icofont icofont-email"></i>
                    </label>
                    <input
                      autocomplete="off"
                      formControlName="email"
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Please type in your email"
                      class="name-group"
                      (keydown.enter)="$event.preventDefault()"
                    />
                  </div>

                  <div
                    class="messages text-danger validation-error-message"
                    *ngIf="authForm.controls.email.errors?.required"
                  >
                    Email is required
                  </div>
                </div>
                <!-- end email -->

                <!-- start password -->
                <div class="j-span12 j-unit">
                  <div class="j-input">
                    <label class="j-icon-left" for="password">
                      <i class="icofont icofont-user-alt-2"></i>
                    </label>
                    <input
                      autocomplete="off"
                      formControlName="password"
                      type="password"
                      id="password"
                      name="password"
                      placeholder="Please enter password"
                      class="name-group"
                      (keydown.enter)="$event.preventDefault()"
                    />
                  </div>

                  <div
                    class="messages text-danger validation-error-message"
                    *ngIf="authForm.controls.password.errors?.required"
                  >
                    Password is required
                  </div>
                </div>
                <!-- end password -->
              </div>
            </div>
            <!-- end /.content -->
            <div class="j-footer">
              <button
                [disabled]="isSubmitting"
                type="submit"
                class="btn btn-danger"
                (click)="attemptLocalAuth()"
              >
                <i class="icofont icofont-trash"></i>
                <span> Delete </span>
              </button>
            </div>
            <!-- end /.footer -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
